import { InventoryAdjustmentReasons } from '@/domains/adjustment-groups/types/consts/AdjustmentReason.consts'

/**
 * Inventory adjustment creation request.
 *
 * Backend: Domain\Inventory\DataTransferObjects\InventoryAdjustmentDTO
 *
 * `adjusted_quantity` is a signed delta. For every reason except
 * `consignment.correction` it moves the available quantity; for
 * `consignment.correction` it moves the consignment quantity instead.
 */
interface CreateInventoryAdjustmentRequest {
  inventory_item_ulid?: string
  adjusted_quantity: number
  reason: InventoryAdjustmentReasons
  /**
   * Whose consigned goods this moves. Only sent for a `CONSIGNMENT_ONLY_REASONS` reason.
   *
   * ⚠ An inventory item is a (variant, location) pair and carries no supplier, so two suppliers
   * consigning one variant to one shelf are indistinguishable without it. Left null the backend
   * draws from the shelf's oldest lot, which is right for one supplier and refused for two.
   */
  consignment_supplier_id?: string | null
}

/** Reasons that only ever apply to consignment stock. */
const CONSIGNMENT_ONLY_REASONS = [
  InventoryAdjustmentReasons.CONSIGNMENT_RECEIVED,
  InventoryAdjustmentReasons.CONSIGNMENT_RETURNED,
  InventoryAdjustmentReasons.CONSIGNMENT_CORRECTION
]

export { CONSIGNMENT_ONLY_REASONS }
export type { CreateInventoryAdjustmentRequest }
